import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {MessageclientService} from "src/service/messageclient.service";

@Component({
  selector: 'app-mz-modal',
  templateUrl: './mz-modal.page.html',
  styleUrls: ['./mz-modal.page.scss'],
})
export class MzModalPage implements OnInit {
  Reason:string="";
  @Input() configName: string;
  constructor(
    public modal: ModalController,
    public msg:MessageclientService
  ) { }

  ngOnInit() {
    // debugger;
    this.Reason=this["item"];
  }
  

  // 取消按钮
  dismissModal() {
    const that = this;
    that.modal.dismiss({
      "result": "",
      "request":false
    });
    console.log("modal dismiss");

  }

  // 确定按钮
  comfireModal() {
    const that = this;
    if(that.Reason){
      that.msg.Confirm("确定提交吗？","取消","确定").then(res=>{
        if(res){
          that.modal.dismiss({
            "result": this.Reason,
            "request":true
          });
        }
      });
    }else{
      that.msg.Alert("请输入差异原因");
    }
  }
}
